// extracted by mini-css-extract-plugin
export default {"list":"_3od-3"};